import {Grid, styled} from '@mui/material';
import {AvatarInputDiv, TabNameTypography} from '../../modules/home/main/dashboard/DashboardStyles';

export const ContainerGrid = styled(Grid)<{
  color: string;
  borderColor?: string;
}>`
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({borderColor}) => borderColor};
  border-radius: 10px;
  padding: 1rem;
  margin: 0.8rem 1rem;
  cursor: pointer;

  &:hover {
    background-color: ${({color}) => color};
    cursor: pointer;
  }

  &:hover ${AvatarInputDiv} {
    background-color: white;
    color: ${({color}) => color};
    cursor: pointer;
  }

  &:hover ${TabNameTypography} {
    color: white;
    cursor: pointer;
  }
`;
